import { render, staticRenderFns } from "./TestScreeningEdit.vue?vue&type=template&id=1cdb8f32&scoped=true&"
import script from "./TestScreeningEdit.vue?vue&type=script&lang=js&"
export * from "./TestScreeningEdit.vue?vue&type=script&lang=js&"
import style0 from "./TestScreeningEdit.vue?vue&type=style&index=0&id=1cdb8f32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb8f32",
  null
  
)

export default component.exports